import {
  ButtonSizeOptions,
  ButtonTypes,
  Constants,
  cryptoRandomUUID,
  CssConfig,
  DatePickerTypes,
  GridPosition,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import {
  getAllowManualEditFieldConfig,
  getShowHideSuccessErrorIcon,
  getWrapInAddressObjectFieldConfig,
} from '../onboarding/onboarding.type';

export const nameWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.FORM_NAME_WIDGET,
  widgetConfiguration: {
    isVisible: true,
    widgetDisplayName: WidgetTitles.NAME_WIDGET,
    widgetConfigDisplayName: 'Name',
    isRemovable: false,
    attributes: {
      elementsConfig: [getShowHideSuccessErrorIcon(true), getShowHideSuccessErrorIcon()],
      widgetProperties: {
        textContent: '',
      },
      label: 'Name',
      sub_heading: 'Enter your name',
      show: true,
      decision_config: {
        required: true,
      },
      field_attributes: [
        {
          name: 'firstName',
          decision_config: {
            required: true,
          },
          label: 'First Name',
          type: 'text',
          options: [],
          additional_config: {},
        },
        {
          name: 'middleName',
          decision_config: { required: false },
          label: 'Middle Name',
          type: 'text',
          options: [],
          additional_config: {},
        },
        {
          name: 'lastName',
          decision_config: { required: true },
          label: 'Last Name',
          type: 'text',
          options: [],
          additional_config: {},
        },
      ],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderColor: 'var(--color-border-color)',
        borderRadiusBottomRight: 8,
        borderRadiusBottomLeft: 8,
        borderRadiusTopRight: 8,
        borderRadiusTopLeft: 8,
        borderRadiusUnit: 'px',
        borderStyle: 'solid',
        borderWidth: 1,
        textFont: 'var(--font-family)',
      },
    },
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'form-widget',
} as WorkflowWidgetConfig;

export const birthdayWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: Math.floor(Math.random() * (1000000000 + 1)),
  name: WidgetNames.FORM_BIRTHDAY_WIDGET,
  widgetConfiguration: {
    isVisible: true,
    widgetConfigDisplayName: 'Date of Birth',
    widgetDisplayName: 'DOB',
    isRemovable: false,
    attributes: {
      widgetProperties: {
        textContent: '',
        dateType: DatePickerTypes.DATEPICKER,
      },
      elementsConfig: [
        {
          field_name: 'min_age',
          label: 'Minimum Acceptance Age',
          section: 'signup_widget',
          type: '18',
          show: true,
          options: [],
        },
        getShowHideSuccessErrorIcon(true),
        getShowHideSuccessErrorIcon(),
      ],
      label: 'Date of Birth',
      sub_heading: `Enter your date of Birth `,
      show: true,
      field_attributes: [
        {
          name: 'dob',
          label: 'Date of Birth',
          type: 'date',
          options: [],
          decision_config: {
            required: true,
            minimum_age: 18,
          },
          additional_config: {},
        },
      ],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderColor: 'var(--color-border-color)',
        borderRadiusBottomRight: 8,
        borderRadiusBottomLeft: 8,
        borderRadiusTopRight: 8,
        borderRadiusTopLeft: 8,
        borderRadiusUnit: 'px',
        borderStyle: 'solid',
        borderWidth: 1,
        textFont: 'var(--font-family)',
      },
    },
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'form-widget',
} as WorkflowWidgetConfig;

export const onboardingButtonConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: cryptoRandomUUID(),
  name: WidgetNames.ONBOARDING_BUTTON,
  widgetConfiguration: {
    widgetConfigDisplayName: 'Onboarding Button',
    widgetDisplayName: 'Onboarding Button ',
    attributes: {
      elementsConfig: [],
      buttonType: 'next',
      widgetProperties: {
        textContent: 'Continue',
        icon: '',
        globalStyling: true,
        globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
      },
      css_config: {} as CssConfig,
    },
    isRemovable: true,
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'action-button',
};

export const onboardAddressWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: cryptoRandomUUID(),
  name: WidgetNames.FORM_ADDRESS_WIDGET,
  widgetConfiguration: {
    isVisible: true,
    widgetConfigDisplayName: 'Address',
    widgetDisplayName: WidgetTitles.ADDRESS_WIDGET,
    attributes: {
      elementsConfig: [
        getShowHideSuccessErrorIcon(true),
        getShowHideSuccessErrorIcon(),
        getAllowManualEditFieldConfig(),
        getWrapInAddressObjectFieldConfig(false),
      ],
      widgetProperties: {
        textContent: '',
      },
      label: 'Address',
      sub_heading: 'Enter your address',
      show: true,
      field_attributes: [
        {
          name: 'search_address',
          label: 'Address (Search via Postal Code / Address)',
          type: 'search_address',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address1',
          label: 'Address Line 1',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'address2',
          label: 'Address Line 2',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address3',
          label: 'Address Line 3',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address4',
          label: 'Address Line 4',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'county',
          label: 'County',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'city',
          label: 'City',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'postalCode',
          label: 'Post Code',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'country',
          label: 'Country',
          type: 'country',
          decision_config: {},
          options: [],
          additional_config: {},
        },
      ],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderColor: 'var(--color-border-color)',
        borderRadiusBottomRight: 8,
        borderRadiusBottomLeft: 8,
        borderRadiusTopRight: 8,
        borderRadiusTopLeft: 8,
        borderRadiusUnit: 'px',
        borderStyle: 'solid',
        borderWidth: 1,
        textFont: 'var(--font-family)',
      },
    },
    isRemovable: false,
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'form-widget',
};

export const addressHistoryWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: cryptoRandomUUID(),
  name: WidgetNames.FORM_ADDRESS_HISTORY_WIDGET,
  widgetConfiguration: {
    isVisible: true,
    widgetConfigDisplayName: WidgetTitles.FORM_ADDRESS_HISTORY_WIDGET,
    widgetDisplayName: WidgetTitles.FORM_ADDRESS_HISTORY_WIDGET,
    attributes: {
      elementsConfig: [
        getShowHideSuccessErrorIcon(true),
        getShowHideSuccessErrorIcon(),
        getAllowManualEditFieldConfig(),
      ],
      widgetProperties: {
        textContent: '',
        moveInDateLabel: 'When did you move in?',
        datePickerType: 'datepicker',
        minAddressHistoryYears: 3,
        coverageErrorMessage:
          'Please provide a continuous address history of at least {minAddressHistoryYears} years.',
        previousAddressSubheaderText: '',
      },
      label: 'Address History',
      sub_heading: 'Enter manually',
      show: true,
      field_attributes: [
        {
          name: 'search_address',
          label: 'Address (Search via Postal Code / Address)',
          type: 'search_address',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address1',
          label: 'Address Line 1',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'address2',
          label: 'Address Line 2',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address3',
          label: 'Address Line 3',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'address4',
          label: 'Address Line 4',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'county',
          label: 'County',
          type: 'text',
          decision_config: {},
          options: [],
          additional_config: {},
        },
        {
          name: 'city',
          label: 'City',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'postalCode',
          label: 'Post Code',
          type: 'text',
          decision_config: { required: true },
          options: [],
          additional_config: {},
        },
        {
          name: 'country',
          label: 'Country',
          type: 'country',
          decision_config: {},
          options: [],
          additional_config: {},
        },
      ],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderColor: 'var(--color-border-color)',
        borderRadiusBottomRight: 8,
        borderRadiusBottomLeft: 8,
        borderRadiusTopRight: 8,
        borderRadiusTopLeft: 8,
        borderRadiusUnit: 'px',
        borderStyle: 'solid',
        borderWidth: 0,
        textFont: 'var(--font-family)',
      },
    },
    isRemovable: false,
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'form-widget',
};

export const onboardingPasswordWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: cryptoRandomUUID(),
  name: WidgetNames.FORM_PASSWORD_WIDGET,
  widgetConfiguration: {
    isVisible: true,
    widgetConfigDisplayName: WidgetTitles.PASSWORD_WIDGET,
    widgetDisplayName: WidgetTitles.PASSWORD_WIDGET,
    isRemovable: false,
    attributes: {
      widgetProperties: {
        textContent: '',
      },
      elementsConfig: [getShowHideSuccessErrorIcon(true), getShowHideSuccessErrorIcon()],
      label: 'Password',
      sub_heading: 'Set a password for your account',
      show: true,
      field_attributes: [
        {
          name: 'password',
          decision_config: {
            required: true,
          },
          label: 'Password',
          type: 'password',
          options: [],
          additional_config: {},
        },
        {
          name: 'confirm_password',
          decision_config: {
            required: true,
          },
          label: 'Confirm password',
          type: 'password',
          options: [],
          additional_config: {},
        },
      ],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderColor: 'var(--color-border-color)',
        borderRadiusBottomRight: 8,
        borderRadiusBottomLeft: 8,
        borderRadiusTopRight: 8,
        borderRadiusTopLeft: 8,
        borderRadiusUnit: 'px',
        borderStyle: 'solid',
        borderWidth: 1,
        textFont: 'var(--font-family)',
      },
    },
  },
  gridPosition: {} as GridPosition,
  widgetIconPath: 'form-widget',
};
